import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, BIG_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = (isBlock, background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      mainWrapper: {
        paddingTop: isBlock ? 36 : 0,
        paddingBottom: isBlock ? 36 : 0,
        background: theme.palette.secondary.dark,
        '&:first-child': {
          marginTop: isBlock ? 76 : 0,
        },

        [theme.breakpoints.up('md')]: {
          paddingTop: isBlock ? 72 : isBlock,
          paddingBottom: isBlock ? 72 : 160,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          '&:first-child': {
            marginTop: isBlock ? 120 : 0,
          },
        },
      },
      container: {
        flex: 1,
        flexGrow: 1,
        padding: 0,
      },
      root: {
        flexGrow: 1,
      },
      blockClass: {},
      headerClass: {},
      descriptionClass: {},
      intro: {
        height: 500,
        '& $descriptionClass': {
          [theme.breakpoints.up('md')]: {
            fontSize: 26,
            lineHeight: 1.4,
            color: colorsPalette.gray,
          },
        },
        '& $blockClass': {
          [theme.breakpoints.up('md')]: {
            maxWidth: 720,
          },
        },
        '& $headerClass': {
          [theme.breakpoints.up('md')]: {
            fontSize: 48,
            lineHeight: 1,
            marginBottom: SMALL_MARGIN,
          },
        },
        '& .intro-block-container': {
          paddingTop: 30,
        },

        [theme.breakpoints.up('md')]: {
          height: '600px !important',
        },
      },
      title: {
        marginBottom: 6,
      },
      subTitle: {
        fontSize: 20,
        fontWeight: 700,
        lineHeight: 1.4,
        color: colorsPalette.violet,
        textAlign: 'center',
      },
      wrapper: {
        position: 'relative',
        marginTop: isBlock ? 0 : -150,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          marginTop: isBlock ? 0 : -200,
          alignItems: 'flex-start',
        },
      },
      cardsWrapper: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          alignItems: 'flex-start',
          marginRight: -16,
          flexWrap: 'wrap',
          justifyContent: 'center',
        },
        [theme.breakpoints.up('xl')]: {
          flexWrap: 'nowrap',
        },
      },
      card: {
        boxShadow: `0px 3px 6px ${colorsPalette.black}`,
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          width: '33.333%',
          minWidth: 335,
          marginRight: 16,
          transition: 'all .3s ease',

          '&:hover': {
            transform: 'scale(1.06)',
            boxShadow: `0px 3px 12px ${colorsPalette.black}`,
          },
        },
        [theme.breakpoints.up('xl')]: {
          marginBottom: 0,
        },
      },
      pivotCard: {
        '& $innerCard': {
          background: colorsPalette.blueDark,
        },

        [theme.breakpoints.up('md')]: {
          '& $innerCard': {
            paddingTop: 42,
            paddingBottom: 65,
          },
        },
      },
      cardHeader: {
        paddingTop: 32,
        paddingBottom: 32,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        },
      },
      innerCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '24px 24px 64px',
        justifyContent: 'flex-end',
        background: theme.palette.secondary.light,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
      },
      priceBlock: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        fontSize: 28,
        lineHeight: 1.4,
        fontWeight: 700,
        color: colorsPalette.gray,
        '& > div': {
          textAlign: 'right',
          minWidth: 55,
          margin: '0 4px',
        },
      },
      price: {
        color: colorsPalette.white,
        fontSize: 72,
        lineHeight: 1,
        margin: 0,
        '&:nth-child(2)': {
          fontSize: 18,
          '&:before': {
            content: '"."',
            display: 'inline',
          },
        },
      },
      description: {
        fontSize: 18,
        lineHeight: '22px',
        color: colorsPalette.gray,
        marginBottom: 24,
        marginTop: SMALL_MARGIN,
        textAlign: 'center',
        maxWidth: 230,
      },
      featureHeading: {
        fontSize: 18,
        lineHeight: 1.4,
        fontWeight: 700,
        color: colorsPalette.gray,
        marginBottom: 24,
      },
      feature: {
        fontSize: 18,
        lineHeight: 1.8,
        marginBottom: SMALL_MARGIN,
        color: colorsPalette.gray,
        display: 'flex',
        alignItems: 'center',
      },
      featureIcon: {
        display: 'block',
        width: 24,
        height: 24,
        marginRight: SMALL_MARGIN,
      },
      switchWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 75,

        '& span': {
          color: colorsPalette.graySecondary,
          fontSize: 18,
          fontWeight: 'bold',
          lineHeight: '36px',
          textTransform: 'uppercase',
          cursor: 'pointer',
        },
        '& span:first-child': {
          marginRight: 9,
        },
        '& span:last-child': {
          marginLeft: 9,

          '& span': {
            color: colorsPalette.primary,
            textTransform: 'lowercase',
            margin: 0,
          },
        },

        [theme.breakpoints.up('md')]: {
          marginBottom: 55,
        },
      },
      enterpriseHeader: {
        fontSize: 60,
        lineHeight: 1.4,
        marginBottom: BIG_MARGIN,
        color: colorsPalette.white,
        fontWeight: 700,
      },
      btn: {
        marginTop: BIG_MARGIN,
      },
      loaderWrapper: {
        position: 'relative',
        height: 300,
        width: '100%',
        [theme.breakpoints.up('md')]: {
          height: 400,
        },
      },
    }),
  );
export default useStyles;
